module.exports = __webpack_public_path__ + "img/logo-block-light-n.44e25fa6.png";